<template>
  <Modal :show="show" tabindex="-1" @close="closeModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Select a owner</h5>
        </div>
        <div class="modal-body">
          <div class="form-group col-md-12 validated">
            <BaseInputForm
              type="text"
              label="Filter"
              placeholder="Filter by name..."
              v-model="query"
            />
          </div>
          <div class="list-group owner-input mb-3" style="max-height: 50vh; overflow-y: auto">
            <div
              v-for="user in filteredUsers"
              :key="user.id"
              class="list-group-item list-group-item-action"
              :class="{ active: userId === user.id }"
              style="cursor: pointer"
              @click="selectUser(user)"
            >
              <div>
                <strong>{{ user.firstname }} {{ user.lastname }}</strong>
                <p>{{ user.email }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeModal">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/_shared/Modal.vue";
import BaseInputForm from "@/components/_base/BaseInputForm.vue";

export default {
  name: "UserSelectorModal",
  components: {BaseInputForm, Modal},
  data() {
    return {
      query: "",
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      default: 0,
    },
    users: {
      type: Array,
      default: [],
    },
    selectUser: {
      type: Function,
      default: () => {},
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    filteredUsers() {
      const newQuery = this.query.toLowerCase()

      return this.users.filter((user) => {
        if (this.query.length <= 0) return true;

        const firstname = user.firstname ? user.firstname.toLowerCase() : ""
        const lastname = user.lastname ? user.lastname.toLowerCase() : ""
        const email = user.email ? user.email.toLowerCase() : ""

        return (
          firstname.includes(newQuery) ||
          lastname.includes(newQuery) ||
          email.includes(newQuery)
        );
      });
    },
  }
}
</script>

<style scoped>

</style>
